/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'list': {
    width: 30,
    height: 30,
    viewBox: '0 0 30 30',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M15 29c7.732 0 14-6.268 14-14S22.732 1 15 1 1 7.268 1 15s6.268 14 14 14zm0 1c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15C6.716 0 0 6.716 0 15c0 8.284 6.716 15 15 15z" _fill="#fff"/><path pid="1" fill-rule="evenodd" clip-rule="evenodd" d="M8 8v3h2V8H8zM8 13v3h2v-3H8zM8 18v3h2v-3H8zM12 9v1h10V9H12zM12 14v1h10v-1H12zM12 19v1h10v-1H12z" _fill="#fff"/>'
  }
})
